import { ServerResponse } from "../../data/serverResponse";
import { HttpError } from "../../data/types/index";
import { OperationRequestData } from "../../data/operationRequestData";
import Axios, { AxiosResponse } from "axios";
import { appConfig } from "../../config";
import { getFingerPrint } from "../../utilities";

/** Клиент доступа к основному банковскому веб-сервису. */
export class Http {

  static FingerPrintEnable: boolean = false;

  /**
   *  Получение ответа сервера на запрос с учетом базового URL.
   * @param partURL Частичный URL, добавляется к базовому.
   * @param bGetElsePost Признак типа запроса: True - GET, False - POST.
   * @param data Данные запроса.
   * @returns Оттвет сервера в AxiosResponse
   */
  static async sendData(
    partURL: string,
    bGetElsePost: boolean,
    data: any
  ): Promise<AxiosResponse | null> {
    let response: any = null;
    const config = {
      withCredentials: true,
      baseURL: appConfig.apiUrl
    };
    if (data && data.fingerPrintData) {
      if (this.FingerPrintEnable)
        data.fingerPrintData = getFingerPrint();
      else
        data.fingerPrintData = null;
    }
    if (data && data.FingerPrintData) {
      if (!this.FingerPrintEnable)
        return { data: { result: "ok" } } as AxiosResponse;
    }
    if (bGetElsePost) {
      response = await Axios.get(partURL, config);
      if (response && response.config.url === 'WebClient/ApiState') {
        if (response.data.data.CollectFingerPrintEnable === 'true') {
          this.FingerPrintEnable = true;
        }
      }
    } else {
      response = await Axios.post(partURL, data, config);
    }

    return response;
  }

  /**
   * Получение json-ответа сервера на запрос с учетом базового URL.
   * @param partURL Частичный URL, добавляется к базовому.
   * @param bGetElsePost Признак типа запроса: True - GET, False - POST.
   * @param data Данные запроса.
   * @returns JSON-ответ.
   */
  static async jsonSend(
    partURL: string,
    bGetElsePost: boolean,
    data: any
  ): Promise<any> {
    let respData: ServerResponse = new ServerResponse();
    try {
      const response = await this.sendData(partURL, bGetElsePost, data);
      if (!response?.data) throw new Error();
      respData = response.data;
    } catch (err) {
      respData = ServerResponse.error500();
    }

    if (!respData?.result) {
      respData = ServerResponse.error500();
    }

    if (respData.result.toLocaleLowerCase() != "ok") {
      const rmessage = respData.message;
      const rdata = respData.data;

      if (!rmessage && !rdata) respData = ServerResponse.error500();

      if (rmessage == "401") {
        respData = ServerResponse.error401(rdata);
      }
      if (["401", "500"].indexOf(respData.message) >= 0)
        throw new HttpError(respData.message, respData.data);
      else throw new Error(respData.message);
    }

    return respData;
  }

  /**
   * Получение json-ответа сервера на запрос GET с учетом базового URL.
   * @param partURL Частичный URL, добавляется к базовому.
   * @returns JSON-ответ.
   */
  static async get(partURL: string): Promise<ServerResponse> {
    return await this.jsonSend(partURL, true, null);
  }

  /**
   * Получение json-ответа сервера на запрос POST с учетом базового URL.
   * @param partURL Частичный URL, добавляется к базовому.
   * @param data Данные запроса.
   * @returns JSON-ответ.
   */
  static async post(partURL: string, data: any): Promise<ServerResponse> {
    return await this.jsonSend(partURL, false, data);
  }

  /**
   * Выполнение запроса операции.
   * @param partURL Частичный URL, добавляется к базовому.
   * @param ord Данные операции.
   */
  static async operationSendAsync(
    partURL: string,
    ord: OperationRequestData
  ): Promise<any> {
    return await this.post(partURL, ord);
  }


  /**
 * Получение html-ответа сервера на запрос с учетом базового URL.
 * @param partURL Частичный URL, добавляется к базовому.
 * @param bGetElsePost Признак типа запроса: True - GET, False - POST.
 * @param data Данные запроса.
 * @returns html-ответ.
 */
  static async htmlSend(
    partURL: string,
    bGetElsePost: boolean,
    data: any
  ): Promise<any> {
    let respData: any = '';
    let error = ''
    try {
      const response = await this.sendData(
        partURL,
        bGetElsePost,
        data
      );

      if (!response?.data) throw new Error();
      respData = response.data;

      if (respData?.message == "401") {
        respData = ServerResponse.error401();
      }


    } catch (err) {
      respData = ServerResponse.error500();
    }

    if (["401", "500"].indexOf(respData.message) >= 0)
      throw new HttpError(respData.message, respData.data);

    return respData;
  }
}
